module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.56c8d80.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/fontawesome-6.6.0/webfonts/fa-brands-400.ttf
// module id = J47d
// module chunks = 2